<template>
  <layouts-auth>
    <layouts-auth-width>
      <div class="padding-auth-contents">
        <div class="py-2">
          <template v-if="Array.isArray(videos) && videos.length">
            <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-2 sm:gap-3">
              <div v-for="video in pagedList" :key="video.id">
                <router-link
                  :to="`/video/${video.id}`"
                >
                  <video-thumbnail :video="video" />
                </router-link>
              </div>
            </div>
            <div class="flex items-center justify-center mt-10">
              <base-pagination v-model:pagedList="pagedList" :originalList="videos" :pageSize="pageSize" />
            </div>
          </template>
          <template v-else>
            動画が見つかりませんでした。
          </template>
        </div>
      </div>
    </layouts-auth-width>
  </layouts-auth>
</template>

<script lang="ts">
import { defineComponent, onMounted, computed, ref } from 'vue'
import { useStore } from '@/store/index'
import { dayjs } from '@/plugins/dayjs'
import { VideoAttributes } from '@/types/models/video'

import LayoutsAuth from '@/layouts/Auth.vue'
import LayoutsAuthWidth from '@/layouts/AuthWidth.vue'
import BasePagination from '@/components/BasePagination.vue'
import VideoThumbnail from '@/components/VideoThumbnail.vue'

export default defineComponent({
  components: {
    LayoutsAuth,
    LayoutsAuthWidth,
    BasePagination,
    VideoThumbnail
  },
  setup() {
    const store = useStore()
    const videos = computed(() => store.state.video.videos)
    const pageSize = ref(10)
    const pagedList = ref<VideoAttributes[]>([])

    onMounted(() => {
      store.dispatch('video/fetchVideos')
    })

    return {
      dayjs,
      store,
      videos,
      pageSize,
      pagedList
    }
  }
})
</script>
